import { COMPANY_PROFILE_CONFIG } from './company';

// WIP: Entries are added as each entity's pure-layer PR lands (Company first; then
// Contact, Hiring Authority, Candidate, Job Order per the approved build order).
export const ENTITIES = {
  company: COMPANY_PROFILE_CONFIG
};
export {
  COMPANY_DRAWERS,
  COMPANY_PROFILE_CONFIG,
  COMPANY_QUERY_PARAMS,
  COMPANY_TAB_IDS
} from './company';
